import * as React from "react";
import classnames from "classnames";
import { Form } from "@grandvisionhq/forms";
/* empty css              */
const StepForm = ({
  configuratorId,
  onSubmit,
  children,
  className,
  ...rest
}) => /* @__PURE__ */ React.createElement(
  "form",
  {
    noValidate: true,
    onSubmit,
    id: configuratorId,
    "aria-label": rest["aria-label"],
    "data-t": rest["data-t"],
    className: classnames("step-form", className)
  },
  children
);
const ConnectedStepForm = ({
  children,
  initialFormState,
  onChange,
  configuratorId,
  onSubmit,
  className,
  ...rest
}) => {
  const handleSubmit = React.useCallback(() => onSubmit(), [onSubmit]);
  return /* @__PURE__ */ React.createElement(
    Form,
    {
      name: configuratorId,
      "aria-label": rest["aria-label"],
      "data-t": rest["data-t"],
      className: classnames("step-form", className),
      initialFormState,
      onChange,
      onSubmit: handleSubmit
    },
    children
  );
};
export {
  ConnectedStepForm,
  StepForm
};
//# sourceMappingURL=StepForm.js.map
